import { useQuery } from '@tanstack/react-query'
import PropTypes from 'prop-types'
import { ListBox } from 'components/list-box'
import Clickable from 'components/clickable'
import { RegistryBanner } from 'baby-ui/compounds/RegistryBanner/RegistryBanner'
import { RegistryBannerVariant } from 'baby-ui/lib/RegistryBannerVariant'
import { track, useTracking } from 'lib/analytics'
import { getSearchSuggestions, searchStore } from '../helpers'

const Suggestion = ({ item, search }) => {
  const searchIndex = item.toLowerCase().indexOf(search.toLowerCase())
  if (searchIndex > -1) {
    const extracted = item.substring(searchIndex, searchIndex + search.length)
    const [beforeText, afterText] = item.split(extracted)
    return (
      <>
        {beforeText}
        <span className="bold" style={{ background: 'lightyellow' }}>
          {extracted}
        </span>
        {afterText}
      </>
    )
  }
  return <>{item}</>
}

Suggestion.propTypes = {
  item: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
}

const SearchSuggestions = ({
  onBlur,
  inFocus,
  onSearch,
  searchString,
  suggestionTerm,
}) => {
  const { data: suggestions } = useQuery({
    queryKey: ['getSearchSuggestions', suggestionTerm],
    queryFn: () =>
      getSearchSuggestions(
        ['getSearchSuggestions', suggestionTerm],
        suggestionTerm
      ),
  })
  const tracker = useTracking()

  const fireBreastPumpBannerViewedEvent = () => {
    tracker.trackEvent({
      event: track.healthBannerViewed,
      eventCta: 'Check Your Eligibility',
      eventLocation: track.EventLocation.STORE_MINUS_SEARCH_SUGGESTIONS,
      searchTerm: suggestionTerm,
    })
  }

  const fireBreastPumpBannerClickedEvent = () => {
    tracker.trackEvent({
      event: track.healthBannerClicked,
      eventCta: 'Check Your Eligibility',
      eventLocation: track.EventLocation.STORE_MINUS_SEARCH_SUGGESTIONS,
      searchTerm: suggestionTerm,
    })
  }

  if (!suggestions || suggestions.length === 0) {
    return (
      <div className="mtl">
        <RegistryBanner
          query={suggestionTerm}
          variant={RegistryBannerVariant.SearchSuggestionBreastPumpBanner}
          onClick={fireBreastPumpBannerClickedEvent}
          onView={fireBreastPumpBannerViewedEvent}
        />
      </div>
    )
  }

  const options = suggestions.map((item) => ({
    value: item,
    element: (
      <Clickable
        className="link"
        style={{ fontWeight: 'normal' }}
        onClick={() => searchStore(item, onSearch)}
      >
        {item && <Suggestion item={item} search={searchString} />}
      </Clickable>
    ),
  }))

  return (
    <>
      <ListBox
        inFocus={inFocus}
        name="Search Suggestions"
        options={options}
        onBlur={onBlur}
        onSelect={(item) => searchStore(item, onSearch)}
      />
      <RegistryBanner
        query={suggestionTerm}
        variant={RegistryBannerVariant.SearchSuggestionBreastPumpBanner}
        onClick={fireBreastPumpBannerClickedEvent}
        onView={fireBreastPumpBannerViewedEvent}
      />
    </>
  )
}

SearchSuggestions.propTypes = {
  onBlur: PropTypes.func.isRequired,
  inFocus: PropTypes.bool.isRequired,
  onSearch: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,
  suggestionTerm: PropTypes.string.isRequired,
}

export default SearchSuggestions
